<template>
	<div class="avatar" :style="{ width: `${size}px`, height: `${size}px` }">
		<div
			aria-hidden="true"
			class="inner"
			:style="{
				width: `${size - 2 * imageOffset}px`,
				height: `${size - 2 * imageOffset}px`,
				margin: `${imageOffset}px`
			}"
		>
			<img v-if="avatarImg" :src="avatarImg" alt="" />
		</div>
	</div>
</template>
<script>
import UserData from '@/mixins/UserData';

export default {
	mixins: [UserData],
	props: {
		size: {
			type: Number,
			default: 128
		},
		image: {
			type: String,
			default: ''
		}
	},
	data() {
		return { imageOffset: 8 };
	},
	computed: {
		avatarImg() {
			if (this.image) {
				return this.image;
			} else if (this.$store.getters.avatarImg) {
				return this.$store.getters.avatarImg;
			}
			return null;
		}
	}
};
</script>
<style lang="scss" scoped>
.avatar {
	display: flex;
	align-items: center;
	border-radius: 100%;
	background: $avatar-wrapper-color;

	.inner {
		border-radius: 100%;
		background-color: #ffffff;

		img {
			width: 100%;
		}
	}
}
</style>
